import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { encode as base64_encode } from "base-64";
import LandingPage from "../components/LandingPage";
import { ApiName } from "../Constant/ApiName";
import { fetchApiGet } from "../utils/FetchApi";
import tagManagerEvents from "../utils/GoogleTagManager";

type Props = {
  jwtToken: string | null;
};

let subPackage = "";

const LandingPageScreen = (props: Props) => {
  const navigate = useNavigate();
  // state
  const [msisdn, setMsisdn] = useState<string>("");
  const [utm, setUtm] = useState<string | null>("");
  const [otp, setOtp] = useState("");
  const [heFlag, setHeFlag] = useState(false);
  const [error, setError] = useState("");
  const [showErro, setShowErro] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (props.jwtToken != null) {
      handleUtmGet();
    }
  }, [props.jwtToken]);

  // function
  const handleUtmGet = () => {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const utmSource: string | null = searchParams.get("utm_source");
    setUtm(utmSource);
    handleGetFlow(utmSource);
  };

  const handleUserMsisdnInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    let userInputNumber = e.target.value;
    if (
      !userInputNumber ||
      (userInputNumber.length <= 10 && userInputNumber.match(/^3\d{0,9}$/))
    ) {
      setShowErro(false);
      setHeFlag(false);
      setMsisdn(e.target.value);
    }
  };
  const handleOnpressContinueBtn = () => {
    if (msisdn?.length === 10) {
      handleCheckOperator();
      setShowErro(false);
      setLoader(true);
    } else {
      setLoader(false);
      setShowErro(true);
      setError("Please enter 10 digit mobile number");
    }
  };

  // Api Calls
  const handleGetFlow = async (_utm: string | null) => {
    try {
      let endPoint = ApiName.checkHE;
      let response = await fetchApiGet(props.jwtToken, endPoint);

      if (response.status === 200) {
        if (response?.results?.msisdn) {
          tagManagerEvents("DATA_USER", _utm);
          setMsisdn(response.results?.msisdn);
          setHeFlag(true);
        } else {
          tagManagerEvents("WIFI_USER", utm);
        }
      }
    } catch (error) {
      console.log("get flow error" + error);
    }
  };

  const handleCheckOperator = async () => {
    try {
      let endPoint = ApiName.checkOperator + msisdn;
      let response = await fetchApiGet(props.jwtToken, endPoint);
      if (response.status === 200) {
        if (response.results.operator.toLowerCase() !== "other") {
          if (response.results.package.toLowerCase() === "postpaid") {
            subPackage = "postpaid";
          } else {
            subPackage = "prepaid";
          }
          handleCheckUser();
        } else {
          setShowErro(true);
          setLoader(false);
          setError(
            "Service is only available for Jazz customers, kindly enter a working Jazz number"
          );
        }
      } else {
        setShowErro(true);
        setLoader(false);
        setError("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      setShowErro(true);
      setError("Something went wrong");
      console.log("Check Operator" + error);
    }
  };
  const handleCheckUser = async () => {
    try {
      let endPoint = ApiName.checkUser + msisdn;
      let response = await fetchApiGet(props.jwtToken, endPoint);
      console.log("handleCheckUser", response);
      if (response.status === 200) {
        if (response.results.desc.toLowerCase() === "active") {
          if (response.results?.package.toLowerCase() === "subt") {
            handleSignupWeb(false);
          } else {
            handleSignupWeb(true);
          }
        } else {
          handleSignupWeb(false);
        }
      } else {
        setShowErro(true);
        setError("Something went wrong, Please try again.");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      setShowErro(true);
      setError("Something went wrong");
      console.log("check user" + error);
    }
  };
  const handleSignupWeb = async (UserStatus: boolean) => {
    try {
      let endPoint = "";
      if (UserStatus) {
        endPoint = `${ApiName.signupwebActive}?msisdn=${msisdn}&os=""`;
      } else {
        endPoint = `${ApiName.signupweb}?msisdn=${msisdn}&os=""`;
      }
      let response = await fetchApiGet(props.jwtToken, endPoint);
      if (response.status === 200 && response.results.result === 0) {
        tagManagerEvents("REQUEST_OTP", utm);
        let data = {
          msisdn: msisdn,
          otp: response.results.desc,
          heFlag: heFlag,
          utm: utm,
          checkUserStatus: UserStatus,
          subPackage: subPackage,
          uuid: response.results.uuid,
        };
        navigate("/otp", {
          state: data,
        });
        setLoader(false);
      } else {
        setLoader(false);
        setShowErro(true);
        setError("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      setShowErro(true);
      setError("Something went wrong");
      console.log("signUpWeb" + error);
    }
  };
  return (
    <>
      <LandingPage
        msisdn={msisdn}
        handleUserMsisdnInput={handleUserMsisdnInput}
        handleOnpressContinueBtn={handleOnpressContinueBtn}
        error={error}
        loader={loader}
        showErro={showErro}
      />
    </>
  );
};

export default LandingPageScreen;
